// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1RcK8","question":"Question_question__1miho","description":"Question_description__3AeTD"};